module.exports = __webpack_public_path__ + "img/design proposal_demo-10.9ccf667d.jpg";